import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import AboutView from '../views/AboutView.vue'
import SkillsetView from '../views/SkillsetView.vue'
import ProjectsView from '../views/ProjectsView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView
  },
  {
    path: '/skillset',
    name: 'skillset',
    component: SkillsetView
  },
  {
    path: '/projects',
    name: 'projects',
    component: ProjectsView
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
